import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/gio-hang/components/gio-hang-client.tsx");
